import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { ConsumerRolesState } from "../../models/consumer-admin/consumer-roles.state";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerAdminSelectors } from "../../selectors/consumer-admin.selectors";

@Injectable()
export class ActiveVendorOwnersGetEffects {
	getLocal = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.activeVendorOwners.get),
			withLatestFrom(this.store.select(ConsumerAdminSelectors.getActiveVendorOwners)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(ConsumerAdminActions.activeVendorOwners.getSuccess(state))
					: of(ConsumerAdminActions.activeVendorOwners.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.activeVendorOwners.getApi),
			switchMap(() =>
				this.consumerAdminService.getActiveVendorOwners().pipe(
					switchMap((getActiveVendorOwners) =>
						of(
							ConsumerAdminActions.activeVendorOwners.getSuccess({
								getActiveVendorOwners
							})
						)
					),
					catchError((error) =>
						of(ConsumerAdminActions.activeVendorOwners.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}

	private canUseStoreValue(state: ConsumerRolesState): boolean {
		return !_.has(state, "error") && !state.loading && !_.has(state, "roles");
	}
}
